import React from 'react';
import { Button, ButtonProps } from './button.component';
import { toCSV, Headers } from 'react-csv/lib/core';

export const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
export const buildURI = (data: object[], headers: Headers): string => {
  const csv = toCSV(data, headers);
  const type = isSafari() ? 'application/csv' : 'text/csv';
  const blob = new Blob([ csv ], { type });
  const dataURI = `data:${type};charset=utf-8,${csv}`;
  const URL = window.URL || window.webkitURL;

  return (typeof URL.createObjectURL === 'undefined')
    ? dataURI
    : URL.createObjectURL(blob);
};

export const downloadCSV = (data: object[], headers: Headers, filename: string) => {
  const csvURL = buildURI(data, headers);
  const a = document.createElement('a');

  a.download = filename;
  a.href = csvURL;
  a.target = '_blank';
  a.click();
};


export const DownloadCSVButton: React.VFC<ButtonProps & {
  filename: string;
  headers: Headers;
  data: Record<string, unknown>[];
  onClick?: never;
  onSuccess?: () => void;
}> = ({ filename, headers, data, onSuccess, onClick: _onClick, ...props }) => {
  return (
    <Button
      onClick={async () => {
        downloadCSV(data, headers, filename);
        onSuccess?.();
      }}
      {...props}
    />
  );
};
